import { InputLabel, FormControl, Select } from '@mui/material';
import NoOptionsItem from './NoOptionsItem';
import { useMemo } from 'react';
import { SelectProps } from '@mui/material/Select/Select';
import { SelectChangeEvent } from '@mui/material/Select/SelectInput';

export type CustomSelectProps<T> = {
    height?: string;
    defaultColDef?: any;
    onChange: (value: T) => void;
    label: string;
    selectedValue: SelectProps<T>['value'];
    options: any[];
} & Omit<SelectProps<T>, 'onChange' | 'value'>;

function CustomSelect<T>({ children, selectedValue, options, onChange, label, ...props }: CustomSelectProps<T>) {
    const cmpId = useMemo(() => {
        return props.id || 'custom-select-' + Math.random().toString(36).substring(7);
    }, [props.id]);

    const handleChange = (event: SelectChangeEvent<unknown>) => {
        onChange(event.target.value as T);
    };

    return (
        <FormControl fullWidth={true} id={cmpId + '-form-control'}>
            <InputLabel id={cmpId + '-label'}>{label}</InputLabel>
            <Select
                labelId={cmpId + '-label'}
                id={cmpId}
                value={selectedValue}
                onChange={handleChange}
                autoWidth
                label={label}
                {...props}
            >
                {options?.length === 0 && <NoOptionsItem />}
                {children}
            </Select>
        </FormControl>
    );
}

export default CustomSelect;
